var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNearInsider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8.258 7.338",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m73.191 180.684-.01-1.145 3.228.016v4.976l-6.5-4.97c.278-.005.556-.008.835-.011l5.268 4.07-.006-3.62-2.338.006v.988l-.478-.31zM73.125 184.435l.011 1.145-3.228-.017v-4.975l6.5 4.97-.835.01-5.269-4.068.006 3.619 2.339-.006v-.988l.477.31zM69.047 186.877h.13l-.003-.376.334.376h.127l.003-.58H69.5v.372l-.318-.372h-.135v.58zM73.098 186.877h.13l-.003-.376.334.376h.127l.003-.58h-.138v.372l-.318-.372h-.135zM69.993 186.297h-.136v.58h.136z",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-69.047 -179.539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.452 186.297h-.595v.122h.595zM70.452 186.755h-.595v.121h.595zM70.336 186.526h-.479v.122h.479zM76.012 186.297h-.136v.58h.136z",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-69.047 -179.539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.47 186.297h-.594v.122h.595zM76.47 186.755h-.594v.121h.595zM76.355 186.526h-.479v.122h.479zM70.673 186.877l.235-.581h.116l.25.58h-.31v-.107h.116l-.113-.288-.148.395h-.146zM71.612 186.297h-.135v.58h.135zM72.081 186.297h-.135v.35h.135z",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-69.047 -179.539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.993 186.297h-.479v.122h.479zM72.081 186.526h-.478v.122h.478z",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-69.047 -179.539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.705 186.63.223.247h.162l-.238-.263c-.049.006-.098.01-.147.017zM72.885 186.296h-.135v.58h.135zM74.04 186.297h-.136v.348h.135zM74.51 186.529h-.136v.347h.135z",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-69.047 -179.539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.509 186.297H74v.122h.508zM74.509 186.526h-.605v.122h.605zM74.509 186.755h-.605v.121h.605zM74.851 186.297h-.135v.58h.135zM76.827 186.297h-.135v.58h.135zM77.296 186.297h-.135v.35h.135z",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-69.047 -179.539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.208 186.297h-.479v.122h.479zM77.296 186.526h-.478v.122h.478z",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-69.047 -179.539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.92 186.63.223.247h.162l-.238-.263c-.05.006-.098.01-.147.017zM75.202 186.297h-.135v.58h.135z",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-69.047 -179.539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.547 186.297h-.48v.122h.48zM75.547 186.755h-.48v.121h.48z",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-69.047 -179.539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.667 186.413h-.135v.348h.135z",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-69.047 -179.539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.667 186.413-.095.096-.119-.117.094-.095zM75.667 186.76l-.095-.095-.119.116.094.096z",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-69.047 -179.539)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearInsider);
export default __webpack_public_path__ + "static/media/near_insider.9f22d7366d0a3186dc0bbc008e400605.svg";
export { ForwardRef as ReactComponent };